// extracted by mini-css-extract-plugin
export default {"blockheading":"style_blockheading__2iTJT"};